import { Burden } from '@deqo/foundation';
import { ClientManager, Component } from '../../../../concepts/objects';
import { ActiveObject, resolve } from '../../../Container';
import { AdapterInfo } from '../../AdapterInfo';
import { Camera } from '../../Camera';
import { EditorSession } from '../../EditorSession';
import { MyRoleInfo } from '../../MyRoleInfo';
import { PointerInfo } from '../../PointerInfo';
import { Secret } from '../../entities/Secret';
import { ToolInfo } from '../../tooling/ToolInfo';

export class PresenceMechanics extends ActiveObject {

    @resolve(Camera) private camera: Camera;
    @resolve(ClientManager) private clients!: ClientManager;
    @resolve(EditorSession) session!: EditorSession;

    private trash = [] as Burden[];

    public start(): void {
        this.burden(() => Burden.resolveAll(this.trash));
        this.burden(this.session.observe(MyRoleInfo, this.sync));
        this.sync();
    }

    private sync = () => {
        if (this.destroyed()) return;
        Burden.resolveAll(this.trash);
        this.trash = [];

        const { canParticipate } = this.session.get(MyRoleInfo);
        if (!canParticipate) return;

        this.trash = canParticipate ? [
            this.session.observe(AdapterInfo, this.doSubmitAdapterPresence),
            this.session.observe(PointerInfo, this.doSubmitPointerPresence),
            this.session.observe(PointerInfo, this.doSubmitPointerVisibility),
            this.session.observe(ToolInfo, this.doSubmitToolPresence),
        ] : [];
    };

    private doSubmitPointerPresence = (pi: PointerInfo) => {
        // Sometimes we can submit after a disconnect if the tab is idle
        if (this.clients.destroyed()) return;
        const mpt = this.camera.toModel(pi.position);
        this.clients.self.patch({ px: mpt.x, py: mpt.y });
    };

    private doSubmitPointerVisibility = (pi: PointerInfo) => {
        // Sometimes we can submit after a disconnect if the tab is idle
        if (this.clients.destroyed()) return;
        const curr = !!this.clients.self.get('pv');
        const next = !pi.targets.some(x => (x instanceof Component) && x.is(Secret));
        if (curr !== next) {
            this.clients.self.patch({ pv: next });
        }
    };

    private doSubmitToolPresence = (ti: ToolInfo) => {
        this.clients.self.patch({ pt: `${ti.id}:${ti.state}` });
    };

    private doSubmitAdapterPresence = (ai: AdapterInfo) => {
        this.clients.self.patch({ pa: `${ai.target}:${ai.target}` });
    };
}
